/**
 * @description Understanding bot level
 * - starting by “DM” : bot fully understood the question
 * - starting by “RW” : bot partially understood the question and suggest one or more rewording (links)
 * - starting by “GB” : bot doesn't undertand the question at all
 * - starting by “ERR” : bot encounter a technical issue
 */

export default Object.freeze({
  SUCCESS: 'DM',
  PARTIAL: 'RW',
  FAIL: 'GB',
  ERROR: 'ERR',
})
